import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  align-items: center;\n  padding: 11.5px 0;\n\n  a[href] {\n    img {\n      display: inline;\n      margin-right: ", ";\n    }\n\n    ", " {\n      vertical-align: middle;\n    }\n\n    &:hover ", " {\n      text-decoration: none;\n      display: inline-block;\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  font-size: 1.9rem;\n  line-height: 1.65rem;\n  text-transform: none;\n  display: inline;\n\n  @media (max-width: ", ") {\n    font-size: 1.75rem;\n    line-height: 1.5rem;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  && {\n    position: sticky;\n    top: 0;\n    background: white;\n    z-index: ", ";\n    width: 100%;\n    box-shadow: 0px 4px 16px rgba(10, 41, 57, 0.08);\n    height: initial; /* Ant sets a height, we need to unset that. */\n    padding: 0;\n    transition: top 200ms ease-in-out;\n    line-height: initial;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding-top: 0;\n  padding-bottom: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import { findDOMNode } from 'react-dom';
import styled from 'styled-components';
import Columns from '../columns';
import Layout from '../layout';
import { AI2Banner } from './AI2Banner';
var AppLayoutContext = Layout.AppLayoutContext;

var Header = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Header, _React$PureComponent);

  var _super = _createSuper(Header);

  function Header(props) {
    var _this;

    _classCallCheck(this, Header);

    _this = _super.call(this, props);
    _this.container = null;
    _this.lastScrollY = 0;

    _this.onScroll = function () {
      // This implements logic that:
      //  1. If the user scrolls down the page, at all, the AI2 banner at the top is hidden.
      //  2. If the user scrolls up, at all, the AI2 banner becomes visible again.
      if (_this.banner.current !== null) {
        var distance = window.scrollY - _this.lastScrollY;
        _this.lastScrollY = window.scrollY;
        var isCollapsed = distance > 0;

        _this.setState({
          isCollapsed: isCollapsed
        });
      }
    };

    _this.state = {
      isCollapsed: false,
      currentHeaderHeight: 0
    };
    _this.banner = React.createRef();
    return _this;
  }

  _createClass(Header, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('scroll', this.onScroll);

      if (this.container !== null) {
        var maybeNode = findDOMNode(this.container);

        if (maybeNode instanceof HTMLElement) {
          var currentHeaderHeight = maybeNode.getBoundingClientRect().height;
          this.setState({
            currentHeaderHeight: currentHeaderHeight
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.onScroll);
    }
  }, {
    key: "getTopOffset",
    value: function getTopOffset() {
      if (!this.props.alwaysVisible && this.state.isCollapsed && this.banner.current !== null) {
        return -1 * (this.banner.current.getBoundingClientRect().height - parseFloat(window.getComputedStyle(this.banner.current).paddingBottom || '0'));
      }

      return 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(AppLayoutContext.Consumer, null, function (_ref) {
        var setHeaderHeight = _ref.setHeaderHeight;

        var offset = _this2.getTopOffset();

        setHeaderHeight(_this2.state.currentHeaderHeight + offset);
        return /*#__PURE__*/React.createElement(Sticky, {
          ref: function ref(instance) {
            _this2.container = instance;
          },
          style: {
            top: "".concat(offset, "px")
          }
        }, /*#__PURE__*/React.createElement(AI2Banner, {
          ref: _this2.banner
        }), /*#__PURE__*/React.createElement(HeaderContent, null, _this2.props.children));
      });
    }
  }]);

  return Header;
}(React.PureComponent);

export { Header as default };
var HeaderContent = styled(Layout.Content)(_templateObject());
var Sticky = styled(Layout.Header)(_templateObject2(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.zIndex.header;
});
export var HeaderTitle = styled.h5(_templateObject3(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.xs;
});
export var HeaderColumns = styled(Columns)(_templateObject4(), function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacing.xs;
}, HeaderTitle, HeaderTitle);